<script>export let maskInput = false;
export let inputType = maskInput ? 'password' : 'tel';
export let value = '';
export let componentIndex;
export let placeholder = '';
export let customInputWrapperClass = '';
export let customInputClass = '';
export let handleChange;
export let dataAttr = '';
let component;
function onChange(e) {
    value = e.target.value;
    if (handleChange) {
        handleChange(componentIndex, e);
    }
}
</script>

<svelte:window />

<div class={`${customInputWrapperClass} textcontainer`}>
  <input
    name="input"
		type={inputType}
		{placeholder}
		{value}
		on:input={onChange}
		maxlength={1}
		class={`${customInputClass} inputclass`}
		bind:this={component}
    data-testid={dataAttr}
    data-input={'elem'}
		/>
</div>

<style>
  @import './textinput.css';
</style>
